import { render, staticRenderFns } from "./AccessCounts.vue?vue&type=template&id=d72de1ce&scoped=true&"
import script from "./AccessCounts.vue?vue&type=script&lang=ts&"
export * from "./AccessCounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72de1ce",
  null
  
)

export default component.exports